import StyledContainer from "@GlobalComponents/StyledContainer";
import styled from "styled-components";

export const Container = styled(StyledContainer)`
  gap: 8px;

  &.single-column {
    > div {
      max-width: calc(50% - 4px);
    }
  }

  button {
    margin-top: 18px;
  }
`;

export const Title = styled.h2`
  font-size: 2rem;
  line-height: 2.5rem;
  margin: 32px 0 0;
`;

export const Row = styled(StyledContainer)`
  align-items: flex-start;
  gap: 16px;
`;
